<template>
  <div class="ai-text" v-loading="control.aiTextLoading">
    <configure-item label="AI 解读">
      <div class="ai-text__content">
        <el-input
          v-model="draft"
          type="textarea"
          :rows="8"
          resize="vertical"
          :disabled="!hasAiText || saving"
          :placeholder="textareaPlaceholder"
        ></el-input>
        <div v-if="missingMessage" class="ai-text__warning">
          {{ missingMessage }}
        </div>
        <div class="ai-text__actions">
          <ai-action-button :disabled="!canSubmit" :loading="busy" @click="handleSubmit">
            {{ actionText }}
          </ai-action-button>
        </div>
      </div>
    </configure-item>
  </div>
</template>

<script>
import AiActionButton from "./AiActionButton";

const normalizeImageUrl = (value) =>
  String(value || "")
    .trim()
    .replace(/^https?:/, "")
    .split(/[?#]/)[0];

export default {
  name: "AiComponentText",
  inject: ["control"],
  components: { AiActionButton },
  props: {
    widget: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      draft: "",
    };
  },
  computed: {
    record() {
      return this.control.aiTextComponents[this.widget.id] || null;
    },
    currentImageUrl() {
      return (this.widget.value && this.widget.value.imagePath) || "";
    },
    activeRecord() {
      if (!this.record || !this.currentImageUrl) return null;
      return normalizeImageUrl(this.record.imageUrl) === normalizeImageUrl(this.currentImageUrl)
        ? this.record
        : null;
    },
    saving() {
      return Boolean(this.control.aiComponentSaving[this.widget.id]);
    },
    generating() {
      const localGenerating = this.control.aiComponentGenerating[this.widget.id];
      const status = this.activeRecord && this.activeRecord.status;
      return Boolean(localGenerating || ["pending", "running", "retry_wait"].includes(status));
    },
    busy() {
      return this.saving || this.generating;
    },
    hasAiText() {
      return Boolean(
        this.activeRecord &&
          typeof this.activeRecord.aiText === "string" &&
          this.activeRecord.aiText.trim()
      );
    },
    actionText() {
      if (this.generating) return "生成中...";
      return this.hasAiText ? "更新解读" : "生成解读";
    },
    textareaPlaceholder() {
      return this.hasAiText ? "请输入 Markdown 格式的图片解读" : "生成解读后可在此编辑";
    },
    missingMessage() {
      const missingFields = [];
      if (!this.widget.routine || !this.widget.routine.modelName) {
        missingFields.push("模块名称");
      }
      if (!this.widget.value || !this.widget.value.imagePath) {
        missingFields.push("图片");
      }
      return missingFields.length ? `请先补全${missingFields.join("和")}` : "";
    },
    canSubmit() {
      return !this.missingMessage && !this.busy;
    },
  },
  watch: {
    activeRecord: {
      immediate: true,
      handler(value) {
        this.draft = value && value.aiText ? value.aiText : "";
      },
    },
  },
  methods: {
    handleSubmit() {
      if (!this.canSubmit) return;
      if (this.hasAiText) {
        this.control.saveComponentAiText(this.widget.id, this.draft);
      } else {
        this.control.generateComponentAiText(this.widget.id, this.currentImageUrl);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ai-text {
  border-top: 1px solid #ebeef5;

  &__content {
    width: 330px;
  }

  &__warning {
    margin-top: 6px;
    color: #e6a23c;
    font-size: 12px;
    line-height: 18px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}
</style>
